import React from "react";
import { Typography, Box, useMediaQuery } from "@mui/material";
import image from "../../../../assets/spotlight3.png";
import { Button, Link } from "pepsico-ds";
import { useDispatch, useSelector } from "react-redux";

import useThemeRender from "../../../../theme/useThemeRender";
import {
  setSummaryDetails,
  setViewPageName,
  setViewSummaryDrawer,
} from "../../../../slices/viewSummarySlice";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { setAlert } from "../../../../slices/spotlightSlice";
import LazyImage from "../../../../utils/LazyImage";
export default function SpotlightCardItem({
  width,
  id,
  card,
  slotNumber,
  setDeleteSlotId,
}) {
  const isDarkTheme = useSelector((state) => state.theme);
  const insideCardBackgroundColorLayer1 = useThemeRender(
    "insideCardBackgroundColorLayer1"
  );
  const isMobile = useMediaQuery("(max-width: 600px)");
  const boxShadowlayerColor1 = useThemeRender("boxShadowlayerColor1");

  const textColorLayer5 = useThemeRender("textColorLayer5");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleRemove = () => {
    dispatch(setAlert(true));
    setDeleteSlotId(slotNumber);
  };
  const handleReplace = () => {
    navigate(`/admin/replace`, {
      state: { content: card },
    });
    console.log(id, "----------");
  };

  const handleViewSummary = () => {
    dispatch(setViewSummaryDrawer(true));
    dispatch(setSummaryDetails(card));
    dispatch(setViewPageName("Documents"));
  };

  console.log(card, "--------cardcard------");

  return (
    <Box
      sx={{
        display: "flex",
        width: width ? width : "397px",
        padding: "24px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "16px",
        borderRadius: "8px",
        background: insideCardBackgroundColorLayer1,
        boxShadow: isMobile
          ? `0px 0px 24px 0px ${boxShadowlayerColor1}`
          : "none",
        border: isDarkTheme ? "none" : "1px solid #D7E5F8",
      }}
      data-testid="spotlight-card"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          alignSelf: "stretch",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z"
            fill={isDarkTheme ? "white" : "#3A3A3A"}
          />
        </svg>
        <Link
          iconTrailing="delete"
          size="medium"
          onClick={handleRemove}
          label="Remove"
          style={{ fontFamily: "Inter" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          padding: "0px",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "12px",
          alignSelf: "stretch",
          borderRadius: "8px",
        }}
      >
        {/* {card.thumbnailUrl ? (
          <img
            src={card.thumbnailUrl}
            alt="spotlight"
            style={{ width: "349px", height: "198px" }}
          />
        ) : (
          <img
            src={image}
            alt="spotlight"
            style={{ width: "349px", height: "198px" }}
          />
        )} */}
        <LazyImage id={card.thumbnailId} height={198} blocksize={true} />
      </Box>
      <Box
        sx={{
          display: "flex",
          height: "24px",
          padding: "2px 8px",
          alignItems: "center",
          gap: "2px",
          borderRadius: "4px",
          backgroundColor: "#FFDCBB", // Orange color
        }}
      >
        <Typography
          sx={{
            color: "#000", // Black color
            fontFeatureSettings: "'liga' off, 'clig' off", // Turn off ligatures and contextual forms
            fontFamily: "Inter", // Font family
            fontSize: "12px", // XSmall font size
            fontStyle: "normal", // Normal font style
            fontWeight: 400, // Regular weight
            lineHeight: "18px", // Line height (150%)
          }}
        >
          Slot {`${slotNumber}`}
        </Typography>
      </Box>
      <Typography
        sx={{
          color: textColorLayer5,
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
          fontSize: "var(--Font-Size-H5, 24px)",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "var(--Line-Height-H5, 32px)",
          minHeight: "64px", // 2 lines * lineHeight (32px)
          overflow: "hidden", // Hides overflowing content
          textOverflow: "ellipsis", // Adds ellipsis
          display: "-webkit-box", // Required for multiline ellipsis
          WebkitBoxOrient: "vertical", // Required for multiline ellipsis
          WebkitLineClamp: 2, // Limit to 2 lines
          alignSelf: "stretch",
        }}
      >
        {card?.title}
      </Typography>
      <Typography
        sx={{
          color: textColorLayer5,
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--Typography-Font-Family-Body, Inter)",
          fontSize: "var(--Font-Size-Body, 16px)",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "var(--Line-Height-Body, 22px)",
          maxHeight: "64px", // 2 lines * lineHeight (32px)
          minHeight: "64px",
          overflow: "hidden", // Hides overflowing content
          textOverflow: "ellipsis", // Adds ellipsis
          display: "-webkit-box", // Required for multiline ellipsis
          WebkitBoxOrient: "vertical", // Required for multiline ellipsis
          WebkitLineClamp: 2, // Limit to 2 lines
          alignSelf: "stretch",
        }}
      >
        {card?.description}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "16px",
          alignSelf: "stretch",
        }}
      >
        <Button
          variant="secondary"
          text="View Summary"
          onClick={handleViewSummary}
          iconTrailing="visibility"
          size="medium"
          className={`${isMobile ? "!text-[12px] !leading-[1.2]" : ""}`}
        />

        <Button
          variant="primary"
          text="Replace"
          onClick={handleReplace}
          iconTrailing="swap_horiz"
          size="medium"
        />
      </Box>
    </Box>
  );
}
SpotlightCardItem.propTypes = {
  width: PropTypes.string, // `width` is an optional string
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // `id` is required and can be a string or number
  card: PropTypes.shape({
    thumbnailUrl: PropTypes.string, // optional string for the card thumbnail
    title: PropTypes.string, // optional string for the card title
    description: PropTypes.string, // optional string for the card description
  }).isRequired, // `card` is required and should be an object with specific properties
  slotNumber: PropTypes.number.isRequired, // `slotNumber` is required and should be a number
  setDeleteSlotId: PropTypes.func.isRequired, // `setDeleteSlotId` is required and should be a function
};
